module.exports = __webpack_public_path__ + "img/icon-restaurant-mini-chart.fb2d5190.png";